export const gutter = 16

// typografy
export const fontWeight = {
  normal: 400,
  bold: 500
}

export const fontSize = {
  standard: '15px',
  small: '14px',
  h1: '28px',
  h2: '22px',
  h3: '18px',
  h4: '15px'
}
export const fontColor = {
  standard: '#252525',
  light: '#7C7C7C',
  extralight: '#CBCBCB'
}
